<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">wh5介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p>
                wh5股票财务分析软件，面向机构和专业投资者，致力于填补股票软件领域在财务分析方面的空白。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        
        
        <div class="details_gn" v-show="num == 1">
            <p>提供财务画像、利润滤镜、风险甄别、EVA分析、定价等工具，为机构投资者提供了上市企业财务报表勾稽重塑、企业资产和盈利透视、盈利质量和财务风险分析、经济利润考量等功能，并结合机构业绩预测建立了一系列企业内在价值的动态估值模型，帮助投资者快速刻画企业基本面肖像、为决策提供重要参考。</p>
            <p>还提供宏观分析、行业分析、历史分析等一篮子股票投资工具，帮助机构研究员划分宏观经济周期，明晰行业内部格局，建立宏观、行业、企业之间的联系，通过研判宏观周期，挖掘热点行业，构建投资组合，寻找买入时机，最终投资一篮子股票。</p>
            <p class="tent">* 仅限使用wh5软件登录</p>
            <p class="tent">* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <a target="_blank" href="https://wh5.wenhua.com.cn/#/buy">>>> 查看更多功能</a>
            <!-- <br>
            <br>
            <p class="detail_title">量化投研</p>
            <p class="tent">量化编写平台：python语言平台，配合文华数据库，编写自由，数据丰富，云计算技术保证运算速度，提高研发效率。</p>
            <p class="tent">文华精选因子库：包含了基本面、市场交易和情绪3个大类14个子类的400多个精选因子。覆盖了当前量化领域的常见因子并持续更新。</p>
            <p class="tent">多因子策略：实现因子库和量化投资方法的融合，提供高效灵活的图表化多因子量化投研、组合优化管理和归因分析。</p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wh5.wenhua.com.cn/#/home" target="_blank">wh5</a>了解软件。</p>
            <p class="tent" style='padding-left:12px;text-indent:-12px;'>
                3.使用wh5的电脑配置要求：<br />
                · X86架构的CPU，4核及以上配置；<br />
                · win7/win2008的64位操作系统，4G内存；<br />
                · win10/win8的64位操作系统，8G内存；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn{
    min-height: 250px;
}
.details_gn p.tent {
    
}
</style>